import { ShareModel } from "Services/API/API";

async function openShare(url?: string, title?: string) {
   const { default: LiquidSpaceEmbedded } = await import("LiquidSpaceEmbedded");
   LiquidSpaceEmbedded.actions["ls-share"]({
      url: url,
      title: title
   })
}

async function openFullShare(collectionId?: string, collectionOwnerId?: string, collectionUrl?: string, shareModel?: ShareModel) {
   const {default: LiquidSpaceEmbedded} = await import("LiquidSpaceEmbedded");

   LiquidSpaceEmbedded.actions["ls-share-full"]({
      collectionId: collectionId,
      collectionOwnerId: collectionOwnerId,
      collectionUrl: collectionUrl,
      shareViewModel: {
         FacebookShareUrl: shareModel?.facebookShareUrl,
         LinkedInShareUrl: shareModel?.linkedInShareUrl,
         TwitterShareUrl: shareModel?.twitterShareUrl
      }
   })
}

export function useShareFavorite() {
   return {
      openShare
   };
}

export function useShareFull() {
   return {
      openFullShare
   };
}